import React from 'react'
import PropTypes from 'prop-types'
import { Table } from 'reactstrap'
import styled from 'styled-components'
import shortid from 'shortid'
import get from 'lodash/get'
import orderBy from 'lodash/orderBy'
import { leave_history_table_header } from '../constants'
import arrow_down from '../../../static/images/arrow-down.svg'
import arrow_up from '../../../static/images/arrow-up.svg'
import { statusColor } from '../helpers/color'
import { FONTS, COLORS } from '../../../constants'

export default class LeaveHistoryTable extends React.Component {
  state={ sort_order: false, sort_column: 0 }

  handleClickSort(column) {
    if (column === this.state.sort_column) {
      this.setState({
        sort_order: !this.state.sort_order,
      })
    } else {
      this.setState({
        sort_order: false,
        sort_column: column,
      })
    }
  }

  sortLeaveHistory = (data) => {
    const { sort_column } = this.state
    const sort_order = this.state.sort_order ? 'asc' : 'desc'
    if (sort_column === 0) {
      return orderBy(data, (item) => {
        const order = {
          'PENDING': 1,
          'APPROVED': 2,
          'CANCEL': 3,
          'REJECTED': 4,
        }
        return order[item.status]
      }, sort_order)
    } else if (sort_column === 1) return orderBy(data, 'leave_type', sort_order)
    else if (sort_column === 2) return orderBy(data, 'default_duration', sort_order)
    else if (sort_column === 3) return orderBy(data, 'days', sort_order)
    else if (sort_column === 4) return orderBy(data, 'approver', sort_order)
    else if (sort_column === 5) return orderBy(data, 'default_submit_date', sort_order)
    return data
  }

  render() {
    const { sort_order, sort_column } = this.state
    let requests = get(this.props, 'requests', [])
    requests = this.sortLeaveHistory(requests)

    return (
    /* eslint no-underscore-dangle: 0 */
      <TableDiv>
        <NewTable bordered hover>
          <Header>
            <tr style={ { fontFamily: 'Gotham' } }>
              {
                leave_history_table_header.map((h) =>
                  (<HeadTable key={ shortid() } onClick={ () => this.handleClickSort(h.value) }>
                    { h.label }
                    { h.value === sort_column && (
                      sort_order && h.value === sort_column ?
                        <Icon src={ arrow_up } alt="logo" />
                        :
                        <Icon src={ arrow_down } alt="logo" />
                    )
                    }
                  </HeadTable>)
                )
              }
            </tr>
          </Header>
          <BodyTable>
            {
              requests.map((d, key) =>
                (<tr
                  key={ shortid() }
                  style={ {
                    hover: '#E5E5E5',
                    background: key === get(this.props, 'rowID') ? '#E5E5E5' : '',
                  } }
                  onClick={ () => this.props.handleClickRow(d._id) }
                >
                  <td style={ {
                    color: statusColor(d.status),
                  } }
                  >
                    <Circle color={ statusColor(d.status) } />
                    { d.status }
                  </td>
                  <td>{ d.leave_type }</td>
                  <td>{ d.duration }</td>
                  <td>{ d.days }</td>
                  <td>{ d.approver }</td>
                  <td>{ d.submit_date }</td>
                </tr>)
              )}
          </BodyTable>
        </NewTable>
      </TableDiv>
    )
  }
}

LeaveHistoryTable.propTypes = {
  handleClickRow: PropTypes.func.isRequired,
}

const NewTable = styled(Table)`
  background: white;
  thead, tbody tr{
    display: table;
    width: 100%;
    table-layout: fixed;
    font-family: ${FONTS.GOTHAM} !important;
    font-size: ${FONTS.SMALL_SIZE};
  }
  @media (max-width: 575.98px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){
    width: 600px ;
    td {
    padding-left: 1%;
  }
  }
  @media (max-width: 767.98px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){
    width: 600px ;
    td {
    padding-left: 1%;
  }
  }
  @media (max-width: 575.98px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
    width: 800px ;
    margin-bottom: 2%;
  }
  @media (max-width: 767.98px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
    width: 800px ;
    margin-bottom: 2%;
  }
`
const BodyTable = styled.tbody`
  width: 100% ;
  display: block ;
  max-height: calc(100vh - 250px);
  overflow-y: scroll;
  ::-webkit-scrollbar {
    display: none;
  }
  @media (max-width: 575.98px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) {
    max-height: calc(100vh - 250px);
  }
  @media (max-width: 767.98px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) {
    max-height: calc(100vh - 250px);
  }
  @media (max-width: 575.98px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
    max-height: calc(100vh - 200px);
  }
  @media (max-width: 767.98px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
    max-height: calc(100vh - 200px);
  }
`
const TableDiv = styled.div`
  padding: 10px;
  @media (max-width: 575.98px) and (-webkit-min-device-pixel-ratio: 2){
    padding-right: 0px;
    padding-left: 0px;
    font-size: 12px;
    width:100vw;
    overflow:scroll;
  }
  @media (max-width: 767.98px) and (-webkit-min-device-pixel-ratio: 2){
    padding-right: 0px;
    padding-left: 0px;
    font-size: 12px;
    width:100vw;
    overflow:scroll;
  }
`
const HeadTable = styled.th`
  color: white;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  cursor: pointer;
  @media (max-width: 575.98px) {
    font-size: 12px;
  }
  @media (max-width: 767.98px) {
    font-size: 12px;
  }
`
const Header = styled.thead`
  background: ${COLORS.TABLE_HEADER_COLOR};
`
const Circle = styled.div`
  display: inline-block;
  height: 10px;
  width: 10px;
  background-color: ${(props) => props.color};
  border-radius: 50%;
  margin-right: 5px;
`
const Icon = styled.img`
  height: 10px;
  margin-left: 5%;
  cursor: pointer;
`



// WEBPACK FOOTER //
// ./src/components/my-leave/table/leave-history.js